import { useMediaQuery } from "@material-ui/core";

export const useIsMobile = () => useMediaQuery("(max-width:768px)");
export const useIsMedium = () => useMediaQuery("(min-width:960px)");
export const useIsLarge = () => useMediaQuery("(min-width:1420px)");
